import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/bulverde")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in Bulverde, TX | Texas Made Shade",
      description: "Custom welded awnings, sail shades, patio & pergola covers, marine canvas and aluminum fabrication for Bulverde & Comal County.",
      image: hero,
      socialTitle: "Custom Awnings & Shade — Bulverde, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving Bulverde and Comal County.",
      keywords: "awnings Bulverde, awning company Bulverde, custom awnings Bulverde, sail shades Bulverde, patio covers Bulverde, pergola covers Bulverde, metal awnings Bulverde, canvas awnings Bulverde, Texas Made Shade",
    }),
    scripts: cityHeadScripts("Bulverde", "Comal County"),
  }),
  component: () => <CityHomePage city="Bulverde" region="Comal County" />,
});
